import { SellerContactDataUi } from '@/components/Seller/SellerProfile/Account/ContactData/SellerContactDataUi';
import { SellerBusinessDataUi } from '@/components/Seller/SellerProfile/Account/SellerBusinessData/SellerBusinessDataUi';
import { SellerContactDataResponse } from '@/data/api/model/sellers/SellersDto';

export function sellerContactDataResponseToSellerContactDataUi(
  input: SellerContactDataResponse
): SellerContactDataUi {
  const ret: SellerContactDataUi = {
    fullName: input.full_name ?? '',
    phone: input.phone ?? '',
    email: input.email ?? '',
    cancelDisabled: true,
    saveDisabled: true,
  };
  return ret;
}

export function sellerContactDataResponseToSellerBusinessDataUi(
  input: SellerContactDataResponse
): SellerBusinessDataUi {
  const ret: SellerBusinessDataUi = {
    businessName: input.name ?? '',
    cancelDisabled: true,
    saveDisabled: true,
  };
  return ret;
}
